module.exports = __webpack_public_path__ + "media/topSection/3-610b9231.png";